import React from 'react';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import Functionalities from '~/src/features/domofon/components/Functionalities';
import { IFunctionality } from '~/src/features/domofon/components/Functionalities/FunctionalityItem';

import * as ST from './styled';

interface IProps {
    functionalitiesItems: IFunctionality[],
    connectBtnHandler: () => void,
}

export enum EMediaWidth {
    sDesktop = '(max-width: 1567px)',
    laptop = '(max-width: 1279px)',
}

const FunctionalitiesBlock: React.FC<IProps> = ({ functionalitiesItems, connectBtnHandler }): JSX.Element => {
    const isDesktop = useMatchMedia(EMediaWidth.sDesktop);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);

    return (
        <ST.Wrapper data-test='functionalities-block'>
            <WideContainer>
                <ST.HeadTitle data-test='functionalities-block-title'>Управляйте домофоном со смартфона</ST.HeadTitle>
                <Functionalities
                    isLaptop={isLaptop}
                    isDesktop={isDesktop}
                    items={functionalitiesItems}
                    data-test='functionalities-block-functionalities'
                />
                {isLaptop && <ST.SBaseButton
                    type={btnTypes.ACCENT}
                    text='Подключить'
                    data-test='functionalities-block-connect-btn'
                    onClick={connectBtnHandler}
                />}
            </WideContainer>
        </ST.Wrapper>
    );
};

export default FunctionalitiesBlock;
